import { render, staticRenderFns } from "./MarketplaceNewInvoice.vue?vue&type=template&id=008a4a2b&scoped=true&"
import script from "./MarketplaceNewInvoice.vue?vue&type=script&lang=js&"
export * from "./MarketplaceNewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceNewInvoice.vue?vue&type=style&index=0&id=008a4a2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a4a2b",
  null
  
)

export default component.exports